import { render } from "./Customer.vue?vue&type=template&id=7b9a9ea0&scoped=true"
import script from "./Customer.vue?vue&type=script&lang=js"
export * from "./Customer.vue?vue&type=script&lang=js"

import "./Customer.vue?vue&type=style&index=0&id=7b9a9ea0&lang=css"
import "./Customer.vue?vue&type=style&index=1&id=7b9a9ea0&lang=css"
import "./Customer.vue?vue&type=style&index=2&id=7b9a9ea0&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b9a9ea0"]])

export default __exports__